import axios from 'axios';

const api = axios.create({
  baseURL: 'https://wallboard.801.midas-cloud.com',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  timeout: 10000
});

// Token management
export const setAuthToken = (token) => {
  if (token) {
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    localStorage.setItem('wallboard_admin_token', token);
  } else {
    delete api.defaults.headers.common['Authorization'];
    localStorage.removeItem('wallboard_admin_token');
  }
};

// Initialize if token exists
const storedToken = localStorage.getItem('wallboard_admin_token');
if (storedToken) {
  setAuthToken(storedToken);
}

// Response interceptor
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);

export default api;
